import { Box } from "@mui/material"
import { HistoryList } from "components/History/HistoryList"
import { useState } from "react"
import { History } from "graphql/types"

export const CommunicationTab = () => {
  const [communicationHistory] = useState<History[]>([])

  return (
    <Box sx={{ p: 2 }}>
      <HistoryList history={communicationHistory} />
    </Box>
  )
}
